import React, { useState } from 'react';
import AnimatedSection from '../components/AnimatedSection';
import { servicesList } from '../data/content';

const Services = () => {
  // WhatsApp number - Replace with your actual WhatsApp number
  const whatsappNumber = "919986352227"; // Format: country code + number without '+' or spaces
  const [hoveredService, setHoveredService] = useState(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [emailForm, setEmailForm] = useState({
    name: '',
    email: '',
    message: ''
  });

  // Function to generate WhatsApp link
  const getWhatsAppLink = (serviceTitle) => {
    const message = `Hi! I'm interested in your "${serviceTitle}" service. Could you please provide more details and pricing information?`;
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
  };

  // Function to handle email enquiry
  const handleEmailEnquiry = (service) => {
    setSelectedService(service);
    setShowEmailModal(true);
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    const subject = `Enquiry about ${selectedService.title} Service`;
    const body = `Name: ${emailForm.name}\nEmail: ${emailForm.email}\n\nMessage:\n${emailForm.message}\n\nService: ${selectedService.title}`;
    window.location.href = `mailto:info@vtechcoders.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Reset form and close modal
    setEmailForm({ name: '', email: '', message: '' });
    setShowEmailModal(false);
    setSelectedService(null);
    
    // Show success message
    alert('Email client opened! Please send the email to complete your enquiry.');
  };

  return (
    <>
      <section style={{ padding: '5rem 0', position: 'relative' }}>
        <div className="container">
          <AnimatedSection animation="fade-up">
            <h2 className="section-title">Our Services</h2>
            <p style={{ textAlign: 'center', color: '#64748b', marginBottom: '3rem' }}>
              Comprehensive IT solutions tailored to your business needs
            </p>
          </AnimatedSection>
          
          <div className="services-grid">
            {servicesList.map((service, idx) => (
              <AnimatedSection key={idx} animation="scale-up" delay={idx * 100}>
                <div 
                  className="service-card"
                  onMouseEnter={() => setHoveredService(idx)}
                  onMouseLeave={() => setHoveredService(null)}
                >
                  {/* Icon Section */}
                  <div className="service-icon">
                    <i className={service.icon}></i>
                  </div>
                  
                  <h3>{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                  
                  {/* Features List */}
                  {service.features && (
                    <div className="features-list">
                      {service.features.map((feature, fIdx) => (
                        <div key={fIdx} className="feature-item">
                          <i className="fas fa-check-circle"></i>
                          <span>{feature}</span>
                        </div>
                      ))}
                      {service.price && (
                        <div className="price-tag">
                          <i className="fas fa-tag"></i>
                          <span>{service.price}</span>
                        </div>
                      )}
                    </div>
                  )}
                  
                  {/* Action Buttons */}
                  <div className="action-buttons">
                    {/* WhatsApp Button */}
                    <a 
                      href={getWhatsAppLink(service.title)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="action-btn whatsapp-btn"
                    >
                      <i className="fab fa-whatsapp"></i>
                      <span>WhatsApp</span>
                    </a>
                    
                    {/* Email Button */}
                    <button 
                      onClick={() => handleEmailEnquiry(service)}
                      className="action-btn email-btn"
                    >
                      <i className="fas fa-envelope"></i>
                      <span>Email Us</span>
                    </button>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Email Modal */}
      {showEmailModal && (
        <div className="modal-overlay" onClick={() => setShowEmailModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>
                <i className="fas fa-envelope"></i>
                Enquiry for {selectedService?.title}
              </h3>
              <button className="modal-close" onClick={() => setShowEmailModal(false)}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            
            <form onSubmit={handleEmailSubmit} className="email-form">
              <div className="form-group">
                <label>
                  <i className="fas fa-user"></i>
                  Your Name *
                </label>
                <input
                  type="text"
                  placeholder="Enter your full name"
                  value={emailForm.name}
                  onChange={(e) => setEmailForm({...emailForm, name: e.target.value})}
                  required
                />
              </div>
              
              <div className="form-group">
                <label>
                  <i className="fas fa-envelope"></i>
                  Email Address *
                </label>
                <input
                  type="email"
                  placeholder="Enter your email address"
                  value={emailForm.email}
                  onChange={(e) => setEmailForm({...emailForm, email: e.target.value})}
                  required
                />
              </div>
              
              <div className="form-group">
                <label>
                  <i className="fas fa-comment"></i>
                  Your Message *
                </label>
                <textarea
                  rows="4"
                  placeholder="Tell us about your requirements..."
                  value={emailForm.message}
                  onChange={(e) => setEmailForm({...emailForm, message: e.target.value})}
                  required
                ></textarea>
              </div>
              
              <div className="modal-buttons">
                <button type="button" className="cancel-btn" onClick={() => setShowEmailModal(false)}>
                  Cancel
                </button>
                <button type="submit" className="submit-btn">
                  <i className="fas fa-paper-plane"></i>
                  Send Enquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style jsx>{`
        /* Services Grid */
        .services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 2rem;
        }
        
        /* Service Card */
        .service-card {
          background: white;
          border-radius: 20px;
          padding: 2rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          transition: all 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
          border: 1px solid rgba(59, 130, 246, 0.1);
          position: relative;
          overflow: hidden;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        
        .service-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(95deg, #3b82f6, #8b5cf6);
          transform: scaleX(0);
          transition: transform 0.4s ease;
        }
        
        .service-card:hover::before {
          transform: scaleX(1);
        }
        
        .service-card:hover {
          transform: translateY(-12px);
          box-shadow: 0 25px 40px rgba(0, 0, 0, 0.12);
          border-color: rgba(59, 130, 246, 0.3);
        }
        
        /* Service Icon */
        .service-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1));
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.5rem;
          transition: all 0.3s ease;
        }
        
        .service-card:hover .service-icon {
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(139, 92, 246, 0.2));
          transform: scale(1.05);
        }
        
        .service-icon i {
          font-size: 2.5rem;
          color: #3b82f6;
          transition: transform 0.3s ease;
        }
        
        .service-card:hover .service-icon i {
          transform: scale(1.1);
        }
        
        /* Title */
        h3 {
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 0.75rem;
          color: #1e293b;
          transition: color 0.3s ease;
        }
        
        .service-card:hover h3 {
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        
        /* Description */
        .service-description {
          color: #64748b;
          line-height: 1.6;
          margin-bottom: 1.5rem;
          font-size: 0.95rem;
        }
        
        /* Features List */
        .features-list {
          margin: 1rem 0;
          flex: 1;
        }
        
        .feature-item {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 0.75rem;
          font-size: 0.9rem;
          color: #475569;
        }
        
        .feature-item i {
          color: #10b981;
          font-size: 0.9rem;
        }
        
        .price-tag {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-top: 1rem;
          padding: 8px 12px;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1));
          border-radius: 10px;
          font-weight: 600;
          color: #3b82f6;
        }
        
        /* Action Buttons */
        .action-buttons {
          display: flex;
          gap: 1rem;
          margin-top: 1.5rem;
        }
        
        .action-btn {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 12px 20px;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          cursor: pointer;
          border: none;
          position: relative;
          overflow: hidden;
        }
        
        .action-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          transition: left 0.5s ease;
        }
        
        .action-btn:hover::before {
          left: 100%;
        }
        
        .action-btn:hover {
          transform: translateY(-2px);
        }
        
        .whatsapp-btn {
          background: linear-gradient(135deg, #25D366, #128C7E);
          color: white;
        }
        
        .whatsapp-btn:hover {
          box-shadow: 0 5px 15px rgba(37, 211, 102, 0.3);
        }
        
        .email-btn {
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
        }
        
        .email-btn:hover {
          box-shadow: 0 5px 15px rgba(59, 130, 246, 0.3);
        }
        
        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.7);
 backdrop-filter: blur(5px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          animation: fadeIn 0.3s ease;
        }
        
        .modal-content {
          background: white;
          border-radius: 20px;
          max-width: 500px;
          width: 90%;
          max-height: 90vh;
          overflow-y: auto;
          animation: slideUp 0.3s ease;
        }
        
        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5rem;
          border-bottom: 1px solid #e2e8f0;
        }
        
        .modal-header h3 {
          margin: 0;
          font-size: 1.3rem;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        
        .modal-close {
          background: none;
          border: none;
          font-size: 1.2rem;
          cursor: pointer;
          color: #64748b;
          transition: color 0.3s ease;
        }
        
        .modal-close:hover {
          color: #ef4444;
        }
        
        .email-form {
          padding: 1.5rem;
        }
        
        .form-group {
          margin-bottom: 1.2rem;
        }
        
        .form-group label {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 0.5rem;
          font-weight: 500;
          color: #1e293b;
        }
        
        .form-group input,
        .form-group textarea {
          width: 100%;
          padding: 10px 12px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-family: inherit;
          transition: all 0.3s ease;
        }
        
        .form-group input:focus,
        .form-group textarea:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }
        
        .modal-buttons {
          display: flex;
          gap: 1rem;
          margin-top: 1.5rem;
        }
        
        .cancel-btn {
          flex: 1;
          padding: 10px;
          background: #e2e8f0;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.3s ease;
        }
        
        .cancel-btn:hover {
          background: #cbd5e1;
        }
        
        .submit-btn {
          flex: 1;
          padding: 10px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all 0.3s ease;
        }
        
        .submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(59, 130, 246, 0.3);
        }
        
        /* Animations */
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes slideUp {
          from {
            transform: translateY(50px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        /* Responsive Styles */
        @media (max-width: 768px) {
          .services-grid {
            grid-template-columns: 1fr;
          }
          
          .service-card {
            padding: 1.5rem;
          }
          
          .service-icon {
            width: 65px;
            height: 65px;
          }
          
          .service-icon i {
            font-size: 2rem;
          }
          
          h3 {
            font-size: 1.3rem;
          }
          
          .action-buttons {
            flex-direction: column;
          }
          
          .action-btn {
            padding: 10px;
          }
          
          .modal-content {
            width: 95%;
          }
        }
        
        /* Dark Mode Support */
        @media (prefers-color-scheme: dark) {
          .service-card {
            background: rgba(30, 41, 59, 0.9);
            border-color: rgba(59, 130, 246, 0.2);
          }
          
          h3 {
            color: #f1f5f9;
          }
          
          .service-description,
          .feature-item {
            color: #94a3b8;
          }
          
          .modal-content {
            background: #1e293b;
          }
          
          .modal-header {
            border-bottom-color: #334155;
          }
          
          .form-group label {
            color: #f1f5f9;
          }
          
          .form-group input,
          .form-group textarea {
            background: #0f172a;
            border-color: #334155;
            color: white;
          }
          
          .cancel-btn {
            background: #334155;
            color: white;
          }
        }
      `}</style>
    </>
  );
};

export default Services;